document.addEventListener('DOMContentLoaded', function () {
	const galleryModal = document.getElementById('galleryModal');

	if (!galleryModal) {
		return;
	}

	// Event listener for when the modal is about to be shown
	galleryModal.addEventListener('show.bs.modal', function (event) {
		// Get the button that triggered the modal
		const button = event.relatedTarget;
		// Extract the image URL from the data attribute
		const imageUrl = button.getAttribute('data-sp-image');

		// Create an image element
		const img = document.createElement('img');
		img.src = imageUrl;
		img.alt = 'Gallery Image';
		img.classList.add('img-fluid'); // Bootstrap class for responsive images

		// Insert the image into the modal body
		const modalBody = galleryModal.querySelector('.modal__body');
		modalBody.appendChild(img);
	});

	// Event listener for when the modal is hidden
	galleryModal.addEventListener('hidden.bs.modal', function () {
		// Clear the modal body
		const modalBody = galleryModal.querySelector('.modal__body');
		modalBody.innerHTML = '';
	});
});